module.exports = __webpack_public_path__ + "media/images/ready/icon-bulb-4e9793ce0070f41cc2f3aa61071d52e4.svg";